import React from 'react';
import PropTypes from 'prop-types';

export default function CloseRoundedIcon({ color }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill={color}/>
      <path d="M13.9591 12.0194L15.9994 9.97162C16.5353 9.4337 16.5327 8.56417 15.9935 8.02947C15.4543 7.49477 14.5828 7.49738 14.0468 8.0353L12.0165 10.0731L9.95156 8.00427C9.41513 7.46682 8.54356 7.46498 8.00485 8.00015C7.46614 8.53533 7.4643 9.40486 8.00072 9.94231L10.0756 12.0211L8.04566 14.0585C7.50971 14.5964 7.51233 15.466 8.05151 16.0007C8.59069 16.5354 9.46226 16.5327 9.99821 15.9948L12.0182 13.9674L13.9999 15.9529C14.5363 16.4903 15.4079 16.4922 15.9466 15.957C16.4853 15.4218 16.4871 14.5523 15.9507 14.0149L13.9591 12.0194Z" fill="white"/>
      <path d="M12 22C6.47715 22 2 17.5228 2 12H-2C-2 19.732 4.26801 26 12 26V22ZM22 12C22 17.5228 17.5228 22 12 22V26C19.732 26 26 19.732 26 12H22ZM12 2C17.5228 2 22 6.47715 22 12H26C26 4.26801 19.732 -2 12 -2V2ZM12 -2C4.26801 -2 -2 4.26801 -2 12H2C2 6.47715 6.47715 2 12 2V-2Z" fill="white"/>
    </svg>

  )
}

CloseRoundedIcon.propTypes = {
  color: PropTypes.string
}

CloseRoundedIcon.defaultProps = {
  color: '#DE350B'
}
